<template>
  <div class="link-generator-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1>推送结果查询</h1>
    </div>

    <!-- 表单部分 -->
    <div class="form-section">
      <van-card class="form-card">
        <template #title>
          <div class="card-title">
            <van-icon name="search" class="card-icon" />
            <span>赛事查询</span>
          </div>
        </template>
        <template #desc>
          <div class="form-content">
            <van-cell-group inset>
              <van-field
                v-model="raceId"
                label="赛事ID"
                placeholder="请输入赛事ID"
                clearable
                :error-message="errorMessage"
                @keydown.enter="goToQuery"
              />
            </van-cell-group>

            <div class="action-buttons">
              <van-button
                type="primary"
                size="large"
                class="generate-btn"
                @click="goToQuery"
                :loading="loading"
              >
                <van-icon name="search" />
                查询结果
              </van-button>
            </div>
          </div>
        </template>
      </van-card>
    </div>

    <!-- 使用说明 -->
    <div class="instructions-section">
      <van-card class="instructions-card">
        <template #title>
          <div class="card-title">
            <van-icon name="question" class="card-icon" />
            <span>使用说明</span>
          </div>
        </template>
        <template #desc>
          <div class="instructions-content">
            <ol>
              <li>在上方输入框中输入赛事ID</li>
              <li>点击"查询结果"按钮跳转到查询页面</li>
              <li>系统将自动显示该赛事的结果信息</li>
            </ol>
          </div>
        </template>
      </van-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "LinkGenerator",
  data() {
    return {
      raceId: "",
      loading: false,
      errorMessage: "",
    };
  },
  methods: {
    // 跳转到查询页面
    goToQuery() {
      // 验证输入
      if (!this.raceId) {
        this.errorMessage = "请输入赛事ID";
        return;
      }

      // 移除了数字类型检查，因为现在接受字符串类型
      this.errorMessage = "";
      this.loading = true;

      // 模拟短暂延迟以提供视觉反馈
      setTimeout(() => {
        this.loading = false;
        // 直接跳转到查询页面，传递赛事ID
        this.$router.push({
          path: '/query',
          query: { race_id: this.raceId }
        });
      }, 500);
    }
  },
};
</script>

<style scoped>
.link-generator-container {
  padding: 16px;
  background: linear-gradient(to bottom, #f5f7fa, #e4efe9);
  min-height: 100vh;
  box-sizing: border-box;
}

.page-header {
  text-align: center;
  margin: 20px 0 30px;
}

.page-header h1 {
  font-size: 24px;
  font-weight: bold;
  color: #34495e;
  margin: 0;
  padding: 10px 0;
  position: relative;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.page-header h1::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, #3498db, #2ecc71);
  border-radius: 3px;
}

.form-section {
  margin-bottom: 25px;
}

.instructions-section {
  margin-bottom: 30px;
}

.form-card,
.instructions-card {
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.card-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 15px;
}

.card-icon {
  margin-right: 8px;
  color: #3498db;
  font-size: 20px;
}

.form-content {
  padding: 5px 0;
}

.action-buttons {
  padding: 0 16px;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.generate-btn {
  border-radius: 8px;
  font-weight: bold;
  background: linear-gradient(to right, #3498db, #2ecc71);
  border: none;
  box-shadow: 0 4px 10px rgba(52, 152, 219, 0.3);
  transition: all 0.3s ease;
}

.generate-btn:active {
  transform: scale(0.98);
}

.instructions-content {
  padding: 10px 0;
}

.instructions-content ol {
  padding-left: 20px;
  margin: 0;
}

.instructions-content li {
  margin-bottom: 10px;
  color: #34495e;
  line-height: 1.5;
}

.instructions-content li:last-child {
  margin-bottom: 0;
}

/* 响应式设计 */
@media (max-width: 320px) {
  .page-header h1 {
    font-size: 20px;
  }

  .card-title {
    font-size: 16px;
  }
}
</style>